module.exports = __webpack_public_path__ + "static/about_system_agenda-f1cd12a9d25f3854b83cae6941fe0b70.png";